module.exports = __webpack_public_path__ + "static/img/1_0040.cc79b61.jpg";


//////////////////
// WEBPACK FOOTER
// ./src/assets/image/tech/1_0040.jpg
// module id = V7pm
// module chunks = 0